import React, { useEffect, useState } from "react";
import { Stack } from "@chakra-ui/react";

import ReusableDrawer from "components/Drawers/ReusableDrawer";
import GradientButton from "components/Buttons/GradientButton";
import ReusableInput from "components/Inputs/ReusableInput";
import headerImage from "../../../../assets/img/longarrow.jpg";
import { formatDate } from "utils/dateFormatter";

const VEHICLE_TYPES = [
  { label: "Car", value: "Car" },
  { label: "Van", value: "Van" },
  { label: "Truck", value: "Truck" },
  { label: "Bus", value: "Bus" },
  { label: "Other", value: "Other" },
];

const EditDriverTripDrawer = ({
  isOpen,
  onClose,
  trip,
  onUpdateTrip,
}) => {
  const [formData, setFormData] = useState({
    trip_id: "",
    origin: "",
    destination: "",
    intermediate_stops: "",
    vehicle_type: "",
    departure_time: "",
    capacity_packages: "",
    created_at: "",
  });

  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    if (trip) {
      setFormData({
        trip_id: trip.trip_id || "",
        origin: trip.origin || "",
        destination: trip.destination || "",
        intermediate_stops:
          trip.intermediate_stops || "",
        vehicle_type: trip.vehicle_type || "",
        departure_time: trip.departure_time
          ? trip.departure_time.slice(0, 16)
          : "",
        capacity_packages:
          trip.capacity_packages || "",
        created_at: trip.created_at || "",
      });

      setIsEditing(false);
    }
  }, [trip]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleToggleEdit = () => {
    if (isEditing) {
      onUpdateTrip({
        ...formData,
        capacity_packages: Number(
          formData.capacity_packages
        ),
      });

      setIsEditing(false);
    } else {
      setIsEditing(true);
    }
  };

  const handleClose = () => {
    setIsEditing(false);
    onClose();
  };

  return (
    <ReusableDrawer
      isOpen={isOpen}
      onClose={handleClose}
      headerImage={headerImage}
      headerContent={
        <h2>
          {isEditing ? "Edit Trip" : "View Trip"}
        </h2>
      }
      bodyContent={
        <Stack spacing={4}>
          {/* Origin */}
          <ReusableInput
            label="Origin"
            name="origin"
            value={formData.origin}
            onChange={handleInputChange}
            placeholder="Enter origin"
            isReadOnly={!isEditing}
          />

          {/* Destination */}
          <ReusableInput
            label="Destination"
            name="destination"
            value={formData.destination}
            onChange={handleInputChange}
            placeholder="Enter destination"
            isReadOnly={!isEditing}
          />

          {/* Intermediate Stops */}
          <ReusableInput
            label="Intermediate Stops"
            name="intermediate_stops"
            value={formData.intermediate_stops}
            onChange={handleInputChange}
            placeholder="Enter intermediate stops"
            type="textarea"
            isReadOnly={!isEditing}
          />

          {/* Vehicle */}
          <ReusableInput
            label="Vehicle Type"
            name="vehicle_type"
            value={formData.vehicle_type}
            onChange={handleInputChange}
            type="select"
            options={VEHICLE_TYPES}
            placeholder="Select vehicle type"
            isReadOnly={!isEditing}
          />

          {/* Departure */}
          <ReusableInput
            label="Departure Time"
            name="departure_time"
            value={formData.departure_time}
            onChange={handleInputChange}
            type="datetime-local"
            isReadOnly={!isEditing}
          />

          {/* Capacity */}
          <ReusableInput
            label="Package Capacity"
            name="capacity_packages"
            value={formData.capacity_packages}
            onChange={handleInputChange}
            type="number"
            placeholder="Enter package capacity"
            isReadOnly={!isEditing}
          />

          {/* Created */}
          <ReusableInput
            label="Date Added"
            name="created_at"
            value={
              formatDate(formData.created_at) || ""
            }
            isReadOnly
            placeholder="Auto-generated"
          />
        </Stack>
      }
      footerContent={
        <Stack
          direction="row"
          spacing={4}
          justifyContent="flex-end"
        >
          <GradientButton
            onClick={handleClose}
            fontSize="15px"
            width="100px"
            height="40px"
          >
            Cancel
          </GradientButton>

          <GradientButton
            onClick={handleToggleEdit}
            fontSize="15px"
            width="100px"
            height="40px"
            isDisabled={
              isEditing &&
              (
                !formData.origin ||
                !formData.destination ||
                !formData.vehicle_type ||
                !formData.departure_time ||
                !formData.capacity_packages
              )
            }
          >
            {isEditing ? "Save" : "Edit"}
          </GradientButton>
        </Stack>
      }
    />
  );
};

export default EditDriverTripDrawer;